export default "__VITE_ASSET__dbfe51f2__"